<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.28,782.5v2.22H6.06v2.22h-6.67v-1.11l-4.44,5.56v6.67l-1.11,1.11h-1.11v-7.78l4.44-5.93v-2.96H8.28z M6.06,789.17
	c4.44,4.44,1.11,10-1.11,13.33H0.5c-2.22-3.33-5.56-8.89-1.11-13.33H6.06z"/>
</svg>

</template>